import { BlurEvent, DataHeader, Snackbar, Textbox } from "@mcleod/components";
import { AutogenLayoutHazardousMaterialsCode } from "./autogen/AutogenLayoutHazardousMaterialsCode";
import { DuplicateId, DuplicateIdProps } from "./DuplicateId";

export class HazardousMaterialsCode extends AutogenLayoutHazardousMaterialsCode {

    override onLoad(): void | Promise<void> {
        this.validateHazardousMaterialsCodeRecordExist();
    }

    private validateHazardousMaterialsCodeRecordExist(): void {
        const hazmatRowUrl = "lme/dispatch/HazardousMaterialsCode?mode=update&key=";
        const validateProps: DuplicateIdProps = {tableName: "hazmat_code", screenName: "HHazardousMaterialsCode", navigateToUrl: hazmatRowUrl};
        DuplicateId.configureIdTextbox(this.textboxHazmatId, validateProps);
    }

    public override doAfterDataHeaderSetup(dataHeader: DataHeader): void {
        dataHeader.promptToSaveChanges();
    }

    textboxHazmatIdOnBlur(event: BlurEvent): void {
        const hazmatId = event.target as Textbox;
        const value = hazmatId.text?.trim() ?? "";
        if (value && (!["NA", "UN"].some(prefix => value.startsWith(prefix)) || value.length !== 6)) {
            Snackbar.showWarningSnackbar("Hazmat ID must start with either 'NA' or 'UN' and be exactly 6 characters long.");
            hazmatId.text = "";
        }
    }
}
